/*getting-started*/
/*anatomy-of-a-workspace*/
/*minimum-requirements*/
/*specifying-packages-in-a-monorepo*/
/*declaring-directories-for-packages*/
/*packagejson-in-each-package*/
/*root-packagejson*/
/*root-turbojson*/
/*package-manager-lockfile*/
/*anatomy-of-a-package*/
/*packagejson-for-a-package*/
/*name*/
/*scripts*/
/*exports*/
/*imports-optional*/
/*source-code*/
/*common-pitfalls*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "构建仓库",
  "description": "首先使用生态系统的约定创建一个仓库。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "turbo 构建于 工作区 之上，工作区 是 JavaScript 生态系统中包管理器的一项功能，允许你将多个包分组到一个存储库中。"
  }, {
    "heading": "",
    "content": "¥turbo is built on top of Workspaces, a feature of package managers in the JavaScript ecosystem that allows you to group multiple packages in one repository."
  }, {
    "heading": "",
    "content": "遵循这些约定非常重要，因为它可以让你："
  }, {
    "heading": "",
    "content": "¥Following these conventions is important because it allows you to:"
  }, {
    "heading": "",
    "content": "将这些约定应用于你所有代码库的工具。"
  }, {
    "heading": "",
    "content": "¥Lean on those conventions for all your repo's tooling"
  }, {
    "heading": "",
    "content": "快速、逐步地将 Turborepo 引入现有仓库"
  }, {
    "heading": "",
    "content": "¥Quickly, incrementally adopt Turborepo into an existing repository"
  }, {
    "heading": "",
    "content": "在本指南中，我们将逐步介绍如何设置多包工作区 (monorepo)，以便为 turbo 奠定基础。"
  }, {
    "heading": "",
    "content": "¥In this guide, we'll walk through setting up a multi-package workspace (monorepo) so we can set the groundwork for turbo."
  }, {
    "heading": "入门-getting-started",
    "content": "¥Getting started"
  }, {
    "heading": "入门-getting-started",
    "content": "手动设置工作区结构可能很繁琐。如果你是 Monorepos 新手，我们建议你立即使用具有有效工作区结构的 使用 create-turbo 获取已开始。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥Setting up a workspace's structure can be tedious to do by hand. If you're new to monorepos, we recommend using create-turbo to get started with a valid workspace structure right away."
  }, {
    "heading": "入门-getting-started",
    "content": "然后，你可以查看存储库中本指南中描述的特性。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥You can then review the repository for the characteristics described in this guide."
  }, {
    "heading": "工作区结构-anatomy-of-a-workspace",
    "content": "¥Anatomy of a workspace"
  }, {
    "heading": "工作区结构-anatomy-of-a-workspace",
    "content": "在 JavaScript 中，工作区可以是 单个包，也可以是包的集合。在这些指南中，我们将重点介绍 多包工作区，通常称为 \"monorepo\"。"
  }, {
    "heading": "工作区结构-anatomy-of-a-workspace",
    "content": "¥In JavaScript, a workspace can either be a single package or a collection of packages. In these guides, we'll be focusing on a multi-package workspace, often called a \"monorepo\"."
  }, {
    "heading": "工作区结构-anatomy-of-a-workspace",
    "content": "下面高亮了使 create-turbo 成为有效工作区的结构元素。"
  }, {
    "heading": "工作区结构-anatomy-of-a-workspace",
    "content": "¥Below, the structural elements of create-turbo that make it a valid workspace are highlighted."
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "¥Minimum requirements"
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "软件包管理器描述的软件包"
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "¥Packages as described by your package manager"
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "包管理器锁文件"
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "¥A package manager lockfile"
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "Root package.json"
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "Root turbo.json"
  }, {
    "heading": "最低要求要求-minimum-requirements",
    "content": "package.json in each package"
  }, {
    "heading": "在-monorepo-中指定软件包-specifying-packages-in-a-monorepo",
    "content": "¥Specifying packages in a monorepo"
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "¥Declaring directories for packages"
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "首先，你的包管理器需要描述你的包的位置。我们建议首先将你的包拆分为用于应用和服务的 apps/ 包和用于其他所有内容（例如库和工具）的 packages/ 包。"
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "¥First, your package manager needs to describe the locations of your packages. We recommend starting with splitting your packages into apps/ for applications and services and packages/ for everything else, like libraries and tooling."
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "使用此配置，apps 或 packages 目录中每个包含 package.json 的目录都将被视为一个包。"
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "¥Using this configuration, every directory with a package.json in the apps or packages directories will be considered a package."
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "Turborepo 不支持嵌套包，例如 apps/** 或 packages/**，这是因为 JavaScript 生态系统中的包管理器之间存在行为歧义。使用将一个包放在 apps/a 而另一个包放在 apps/a/b 的结构将导致错误。"
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "¥Turborepo does not support nested packages like apps/** or packages/** due to ambiguous behavior among package managers in the JavaScript ecosystem. Using a structure that would put a package at apps/a and another at apps/a/b will result in an error."
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "如果你想按目录对软件包进行分组，可以使用像 packages/* 和 packages/group/* 这样的通配符来实现，而无需创建 packages/group/package.json 文件。"
  }, {
    "heading": "声明包的目录-declaring-directories-for-packages",
    "content": "¥If you'd like to group packages by directory, you can do this using globs like packages/* and packages/group/* and not creating a packages/group/package.json file."
  }, {
    "heading": "每个包中的-packagejson-packagejson-in-each-package",
    "content": "¥package.json in each package"
  }, {
    "heading": "每个包中的-packagejson-packagejson-in-each-package",
    "content": "在包的目录中，必须有一个 package.json 才能使包管理器和 turbo 能够发现该包。package.json 的要求包 如下所示。"
  }, {
    "heading": "每个包中的-packagejson-packagejson-in-each-package",
    "content": "¥In the directory of the package, there must be a package.json to make the package discoverable to your package manager and turbo. The requirements for the package.json of a package are below."
  }, {
    "heading": "root-packagejson-root-packagejson",
    "content": "根 package.json 是工作区的基础。以下是你在根 package.json 中可以找到的内容的常见示例："
  }, {
    "heading": "root-packagejson-root-packagejson",
    "content": "¥The root package.json is the base for your workspace. Below is a common example of what you would find in a root package.json:"
  }, {
    "heading": "root-turbojson-root-turbojson",
    "content": "turbo.json 用于配置 turbo 的行为。要了解更多关于如何配置任务的信息，请访问 配置任务 页面。"
  }, {
    "heading": "root-turbojson-root-turbojson",
    "content": "¥turbo.json is used to configure the behavior of turbo. To learn more about how to configure your tasks, visit the Configuring tasks page."
  }, {
    "heading": "软件包管理器锁定文件-package-manager-lockfile",
    "content": "¥Package manager lockfile"
  }, {
    "heading": "软件包管理器锁定文件-package-manager-lockfile",
    "content": "锁文件是包管理器和 turbo 可重现行为的关键。此外，Turborepo 使用锁文件来理解工作区内 内部软件包 之间的依赖。"
  }, {
    "heading": "软件包管理器锁定文件-package-manager-lockfile",
    "content": "¥A lockfile is key to reproducible behavior for both your package manager and turbo. Additionally, Turborepo uses the lockfile to understand the dependencies between your Internal Packages within your Workspace."
  }, {
    "heading": "软件包管理器锁定文件-package-manager-lockfile",
    "content": "如果你在运行 turbo 时没有锁文件，你可能会看到不可预测的行为。"
  }, {
    "heading": "软件包管理器锁定文件-package-manager-lockfile",
    "content": "¥If you do not have a lockfile present when you run turbo, you may see\nunpredictable behavior."
  }, {
    "heading": "软件包结构-anatomy-of-a-package",
    "content": "¥Anatomy of a package"
  }, {
    "heading": "软件包结构-anatomy-of-a-package",
    "content": "通常最好开始考虑将包设计为工作区中的独立单元。从高层次来看，每个包几乎就像一个小型的 \"project\"，拥有自己的 package.json、工具配置和源代码。这个想法有其局限性，但它是一个很好的入门思路。"
  }, {
    "heading": "软件包结构-anatomy-of-a-package",
    "content": "¥It's often best to start thinking about designing a package as its own unit within the Workspace. At a high-level, each package is almost like its own small \"project\", with its own package.json, tooling configuration, and source code. There are limits to this idea—but its a good mental model to start from."
  }, {
    "heading": "软件包结构-anatomy-of-a-package",
    "content": "此外，包具有特定的入口点，工作区中的其他包可以使用这些入口点访问该包，这些入口点由 exports 指定。"
  }, {
    "heading": "软件包结构-anatomy-of-a-package",
    "content": "¥Additionally, a package has specific entrypoints that other packages in your Workspace can use to access the package, specified by exports."
  }, {
    "heading": "包的-packagejson-packagejson-for-a-package",
    "content": "¥package.json for a package"
  }, {
    "heading": "name-name",
    "content": "name 字段 用于标识包。它在你的工作区内应该是唯一的。"
  }, {
    "heading": "name-name",
    "content": "¥The name field is used to identify the package. It should be unique within your workspace."
  }, {
    "heading": "name-name",
    "content": "最佳做法是为 内部软件包 使用命名空间前缀，以避免与 npm 注册表上的其他包冲突。例如，如果你的组织名为 acme，则可以将你的包命名为 @acme/package-name。"
  }, {
    "heading": "name-name",
    "content": "¥It's best practice to use a namespace prefix for your Internal Packages to avoid conflicts with other packages on the npm registry. For example, if your organization is named acme, you might name your packages @acme/package-name."
  }, {
    "heading": "name-name",
    "content": "我们在文档和示例中使用 @repo，因为它是 npm 注册表中未使用且不可声明的命名空间。你可以选择保留它或使用你自己的前缀。"
  }, {
    "heading": "name-name",
    "content": "¥We use @repo in our docs and examples because it is an unused, unclaimable namespace on the npm registry. You can choose to keep it or use your own prefix."
  }, {
    "heading": "scripts-scripts",
    "content": "scripts 字段用于定义可在包上下文中运行的脚本。Turborepo 将使用这些脚本的名称来确定在包中运行哪些脚本（如果有）。我们在 正在运行的任务 页面上详细介绍了这些脚本。"
  }, {
    "heading": "scripts-scripts",
    "content": "¥The scripts field is used to define scripts that can be run in the package's context. Turborepo will use the name of these scripts to identify what scripts to run (if any) in a package. We talk more about these scripts on the Running Tasks page."
  }, {
    "heading": "exports-exports",
    "content": "exports 字段 用于指定其他想要使用该包的包的入口点。当你想在另一个包中使用一个包中的代码时，你将从该入口点导入。"
  }, {
    "heading": "exports-exports",
    "content": "¥The exports field is used to specify the entrypoints for other packages that want to use the package. When you want to use code from one package in another package, you'll import from that entrypoint."
  }, {
    "heading": "exports-exports",
    "content": "例如，如果你有一个 @repo/math 包，则可能具有以下 exports 字段："
  }, {
    "heading": "exports-exports",
    "content": "¥For example, if you had a @repo/math package, you might have the following exports field:"
  }, {
    "heading": "exports-exports",
    "content": "请注意，此示例为了简单起见使用了 Just-in-Time 包 模式。它直接导出 TypeScript，但你也可以选择使用 编译包 模式。"
  }, {
    "heading": "exports-exports",
    "content": "¥Note that this example uses the Just-in-Time Package pattern for simplicity. It exports TypeScript directly, but you might choose to use the Compiled Package pattern instead."
  }, {
    "heading": "exports-exports",
    "content": "本例中的 exports 字段需要 Node.js 和 TypeScript 的现代版本。"
  }, {
    "heading": "exports-exports",
    "content": "¥The exports field in this example requires modern versions of Node.js and\nTypeScript."
  }, {
    "heading": "exports-exports",
    "content": "这将允许你从 @repo/math 包中导入 add 和 subtract 函数，如下所示："
  }, {
    "heading": "exports-exports",
    "content": "¥This would allow you to import add and subtract functions from the @repo/math package like so:"
  }, {
    "heading": "exports-exports",
    "content": "以这种方式使用导出有三大好处："
  }, {
    "heading": "exports-exports",
    "content": "¥Using exports this way provides three major benefits:"
  }, {
    "heading": "exports-exports",
    "content": "避免使用 barrel 文件：Barrel 文件是重新导出同一包中其他文件的文件，为整个包创建一个入口点。虽然它们看起来很方便，但它们是 编译器和打包器难以处理 的固有特性，很快就会导致性能问题。"
  }, {
    "heading": "exports-exports",
    "content": "¥Avoiding barrel files: Barrel files are files that re-export other files in the same package, creating one entrypoint for the entire package. While they might appear convenient, they're difficult for compilers and bundlers to handle and can quickly lead to performance problems."
  }, {
    "heading": "exports-exports",
    "content": "更强大的功能：与 main 字段 相比，exports 还具有其他强大的功能，例如 条件导出。一般来说，我们建议尽可能使用 exports 而不是 main，因为它是更现代的选择。"
  }, {
    "heading": "exports-exports",
    "content": "¥More powerful features: exports also has other powerful features compared to the main field like Conditional Exports. In general, we recommend using exports over main whenever possible as it is the more modern option."
  }, {
    "heading": "exports-exports",
    "content": "IDE 自动补全：通过使用 exports 指定包的入口点，你可以确保代码编辑器能够为包的导出提供自动补全功能。"
  }, {
    "heading": "exports-exports",
    "content": "¥IDE autocompletion: By specifying the entrypoints for your package using exports, you can ensure that your code editor can provide auto-completion for the package's exports."
  }, {
    "heading": "imports可选-imports-optional",
    "content": "¥imports (optional)"
  }, {
    "heading": "imports可选-imports-optional",
    "content": "imports 字段 为你提供了一种在软件包中创建指向其他模块的子路径的方法。你可以将这些视为 \"shortcuts\"，以编写更简单的导入路径，这些路径对于移动文件的重构更具弹性。要了解如何操作，请访问 TypeScript 页面。"
  }, {
    "heading": "imports可选-imports-optional",
    "content": "¥The imports field gives you a way to create subpaths to other modules within your package. You can think of these like \"shortcuts\" to write simpler import paths that are more resilient to refactors that move files. To learn how, visit the TypeScript page."
  }, {
    "heading": "imports可选-imports-optional",
    "content": "你可能更熟悉 TypeScript 的 compilerOptions#paths 选项，它可以实现类似的目标。从 TypeScript 5.4 开始，TypeScript 可以从 imports 推断子路径，由于你将使用 Node.js 约定，因此它是一个更好的选择。更多信息请访问 我们的 TypeScript 指南。"
  }, {
    "heading": "imports可选-imports-optional",
    "content": "¥You may be more familiar with TypeScript's compilerOptions#paths option, which accomplishes a similar goal. As of TypeScript 5.4, TypeScript can infer subpaths from imports, making it a better option since you'll be working with Node.js conventions. For more information, visit our TypeScript guide."
  }, {
    "heading": "源代码-source-code",
    "content": "¥Source code"
  }, {
    "heading": "源代码-source-code",
    "content": "当然，你的包中也需要包含一些源代码。包通常使用 src 目录存储其源代码，并编译到 dist 目录（该目录也应位于包内），但这并非强制要求。"
  }, {
    "heading": "源代码-source-code",
    "content": "¥Of course, you'll want some source code in your package. Packages commonly use a src directory to store their source code and compile to a dist directory (that should also be located within the package), although this is not a requirement."
  }, {
    "heading": "常见陷阱-common-pitfalls",
    "content": "¥Common pitfalls"
  }, {
    "heading": "常见陷阱-common-pitfalls",
    "content": "如果你使用的是 TypeScript，则可能不需要在工作区根目录中安装 tsconfig.json。软件包应该独立指定其自身的配置，通常基于工作区中单独软件包的共享 tsconfig.json 构建。更多信息请访问 TypeScript 指南。"
  }, {
    "heading": "常见陷阱-common-pitfalls",
    "content": "¥If you're using TypeScript, you likely don't need a tsconfig.json in the root of your workspace. Packages should independently specify their own configurations, usually building off of a shared tsconfig.json from a separate package in the workspace. For more information, visit the TypeScript guide."
  }, {
    "heading": "常见陷阱-common-pitfalls",
    "content": "你希望尽可能避免跨包访问文件。如果你发现自己需要编写 ../ 来从一个包切换到另一个包，那么你可能有机会重新思考你的方法，方法是将包安装在需要的位置并将其导入到代码中。"
  }, {
    "heading": "常见陷阱-common-pitfalls",
    "content": "¥You want to avoid accessing files across package boundaries as much as possible. If you ever find yourself writing ../ to get from one package to another, you likely have an opportunity to re-think your approach by installing the package where it's needed and importing it into your code."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "配置好工作区后，你现在可以使用包管理器来运行 将依赖安装到你的包中。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥With your Workspace configured, you can now use your package manager to install dependencies into your packages."
  }],
  "headings": [{
    "id": "入门-getting-started",
    "content": "入门 /*getting-started*/"
  }, {
    "id": "工作区结构-anatomy-of-a-workspace",
    "content": "工作区结构 /*anatomy-of-a-workspace*/"
  }, {
    "id": "最低要求要求-minimum-requirements",
    "content": "最低要求要求 /*minimum-requirements*/"
  }, {
    "id": "在-monorepo-中指定软件包-specifying-packages-in-a-monorepo",
    "content": "在 monorepo 中指定软件包 /*specifying-packages-in-a-monorepo*/"
  }, {
    "id": "声明包的目录-declaring-directories-for-packages",
    "content": "声明包的目录 /*declaring-directories-for-packages*/"
  }, {
    "id": "每个包中的-packagejson-packagejson-in-each-package",
    "content": "每个包中的 package.json /*packagejson-in-each-package*/"
  }, {
    "id": "root-packagejson-root-packagejson",
    "content": "Root package.json /*root-packagejson*/"
  }, {
    "id": "root-turbojson-root-turbojson",
    "content": "Root turbo.json /*root-turbojson*/"
  }, {
    "id": "软件包管理器锁定文件-package-manager-lockfile",
    "content": "软件包管理器锁定文件 /*package-manager-lockfile*/"
  }, {
    "id": "软件包结构-anatomy-of-a-package",
    "content": "软件包结构 /*anatomy-of-a-package*/"
  }, {
    "id": "包的-packagejson-packagejson-for-a-package",
    "content": "包的 package.json /*packagejson-for-a-package*/"
  }, {
    "id": "name-name",
    "content": "name /*name*/"
  }, {
    "id": "scripts-scripts",
    "content": "scripts /*scripts*/"
  }, {
    "id": "exports-exports",
    "content": "exports /*exports*/"
  }, {
    "id": "imports可选-imports-optional",
    "content": "imports（可选） /*imports-optional*/"
  }, {
    "id": "源代码-source-code",
    "content": "源代码 /*source-code*/"
  }, {
    "id": "常见陷阱-common-pitfalls",
    "content": "常见陷阱 /*common-pitfalls*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Step, Steps} from '#components/steps';
import {File, Folder, Files} from '#components/files';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#入门-getting-started",
  title: _jsx(_Fragment, {
    children: "入门 "
  })
}, {
  depth: 2,
  url: "#工作区结构-anatomy-of-a-workspace",
  title: _jsx(_Fragment, {
    children: "工作区结构 "
  })
}, {
  depth: 3,
  url: "#最低要求要求-minimum-requirements",
  title: _jsx(_Fragment, {
    children: "最低要求要求 "
  })
}, {
  depth: 3,
  url: "#在-monorepo-中指定软件包-specifying-packages-in-a-monorepo",
  title: _jsx(_Fragment, {
    children: "在 monorepo 中指定软件包 "
  })
}, {
  depth: 4,
  url: "#声明包的目录-declaring-directories-for-packages",
  title: _jsx(_Fragment, {
    children: "声明包的目录 "
  })
}, {
  depth: 4,
  url: "#每个包中的-packagejson-packagejson-in-each-package",
  title: _jsxs(_Fragment, {
    children: ["每个包中的 ", _jsx("code", {
      children: "package.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#root-packagejson-root-packagejson",
  title: _jsxs(_Fragment, {
    children: ["Root ", _jsx("code", {
      children: "package.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#root-turbojson-root-turbojson",
  title: _jsxs(_Fragment, {
    children: ["Root ", _jsx("code", {
      children: "turbo.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#软件包管理器锁定文件-package-manager-lockfile",
  title: _jsx(_Fragment, {
    children: "软件包管理器锁定文件 "
  })
}, {
  depth: 2,
  url: "#软件包结构-anatomy-of-a-package",
  title: _jsx(_Fragment, {
    children: "软件包结构 "
  })
}, {
  depth: 3,
  url: "#包的-packagejson-packagejson-for-a-package",
  title: _jsxs(_Fragment, {
    children: ["包的 ", _jsx("code", {
      children: "package.json"
    }), " "]
  })
}, {
  depth: 4,
  url: "#name-name",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "name"
    }), " "]
  })
}, {
  depth: 4,
  url: "#scripts-scripts",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "scripts"
    }), " "]
  })
}, {
  depth: 4,
  url: "#exports-exports",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "exports"
    }), " "]
  })
}, {
  depth: 4,
  url: "#imports可选-imports-optional",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "imports"
    }), "（可选） "]
  })
}, {
  depth: 3,
  url: "#源代码-source-code",
  title: _jsx(_Fragment, {
    children: "源代码 "
  })
}, {
  depth: 2,
  url: "#常见陷阱-common-pitfalls",
  title: _jsx(_Fragment, {
    children: "常见陷阱 "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 构建于 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#workspace",
        children: "工作区"
      }), " 之上，", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#workspace",
        children: "工作区"
      }), " 是 JavaScript 生态系统中包管理器的一项功能，允许你将多个包分组到一个存储库中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " is built on top of ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#workspace",
        children: "Workspaces"
      }), ", a feature of package managers in the JavaScript ecosystem that allows you to group multiple packages in one repository."]
    }), "\n", _jsx(_components.p, {
      children: "遵循这些约定非常重要，因为它可以让你："
    }), "\n", _jsx(_components.p, {
      children: "¥Following these conventions is important because it allows you to:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "将这些约定应用于你所有代码库的工具。"
        }), "\n", _jsx(_components.p, {
          children: "¥Lean on those conventions for all your repo's tooling"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "快速、逐步地将 Turborepo 引入现有仓库"
        }), "\n", _jsx(_components.p, {
          children: "¥Quickly, incrementally adopt Turborepo into an existing repository"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["在本指南中，我们将逐步介绍如何设置多包工作区 (monorepo)，以便为 ", _jsx(_components.code, {
        children: "turbo"
      }), " 奠定基础。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In this guide, we'll walk through setting up a multi-package workspace (monorepo) so we can set the groundwork for ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "入门-getting-started",
      children: "入门 "
    }), "\n", _jsx(_components.p, {
      children: "¥Getting started"
    }), "\n", _jsxs(_components.p, {
      children: ["手动设置工作区结构可能很繁琐。如果你是 Monorepos 新手，我们建议你立即使用具有有效工作区结构的 ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation",
        children: ["使用 ", _jsx(_components.code, {
          children: "create-turbo"
        }), " 获取已开始"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Setting up a workspace's structure can be tedious to do by hand. If you're new to monorepos, we recommend ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation",
        children: ["using ", _jsx(_components.code, {
          children: "create-turbo"
        }), " to get started"]
      }), " with a valid workspace structure right away."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "然后，你可以查看存储库中本指南中描述的特性。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can then review the repository for the characteristics described in this guide."
    }), "\n", _jsx(_components.h2, {
      id: "工作区结构-anatomy-of-a-workspace",
      children: "工作区结构 "
    }), "\n", _jsx(_components.p, {
      children: "¥Anatomy of a workspace"
    }), "\n", _jsxs(_components.p, {
      children: ["在 JavaScript 中，工作区可以是 ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "单个包"
      }), "，也可以是包的集合。在这些指南中，我们将重点介绍 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#monorepo",
        children: "多包工作区"
      }), "，通常称为 \"monorepo\"。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In JavaScript, a workspace can either be ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "a single package"
      }), " or a collection of packages. In these guides, we'll be focusing on ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#monorepo",
        children: "a multi-package workspace"
      }), ", often called a \"monorepo\"."]
    }), "\n", _jsxs(_components.p, {
      children: ["下面高亮了使 ", _jsx(_components.code, {
        children: "create-turbo"
      }), " 成为有效工作区的结构元素。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Below, the structural elements of ", _jsx(_components.code, {
        children: "create-turbo"
      }), " that make it a valid workspace are highlighted."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "pnpm-lock.yaml",
            green: true
          }), _jsx(File, {
            name: "pnpm-workspace.yaml",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "yarn.lock",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "package-lock.json",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "bun.lock",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "最低要求要求-minimum-requirements",
      children: "最低要求要求 "
    }), "\n", _jsx(_components.p, {
      children: "¥Minimum requirements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#specifying-packages-in-a-monorepo",
            children: "软件包管理器描述的软件包"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#specifying-packages-in-a-monorepo",
            children: "Packages as described by your package manager"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#package-manager-lockfile",
            children: "包管理器锁文件"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#package-manager-lockfile",
            children: "A package manager lockfile"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#root-packagejson",
            children: ["Root ", _jsx(_components.code, {
              children: "package.json"
            })]
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#root-turbojson",
            children: ["Root ", _jsx(_components.code, {
              children: "turbo.json"
            })]
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#packagejson-in-each-package",
            children: [_jsx(_components.code, {
              children: "package.json"
            }), " in each package"]
          })
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "在-monorepo-中指定软件包-specifying-packages-in-a-monorepo",
      children: "在 monorepo 中指定软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Specifying packages in a monorepo"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "声明包的目录-declaring-directories-for-packages",
          children: "声明包的目录 "
        }), _jsx(_components.p, {
          children: "¥Declaring directories for packages"
        }), _jsxs(_components.p, {
          children: ["首先，你的包管理器需要描述你的包的位置。我们建议首先将你的包拆分为用于应用和服务的 ", _jsx(_components.code, {
            children: "apps/"
          }), " 包和用于其他所有内容（例如库和工具）的 ", _jsx(_components.code, {
            children: "packages/"
          }), " 包。"]
        }), _jsxs(_components.p, {
          children: ["¥First, your package manager needs to describe the locations of your packages. We recommend starting with splitting your packages into ", _jsx(_components.code, {
            children: "apps/"
          }), " for applications and services and ", _jsx(_components.code, {
            children: "packages/"
          }), " for everything else, like libraries and tooling."]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsxs(Tab, {
            value: "pnpm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "pnpm-workspace.yaml",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "packages:"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"apps/*\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"packages/*\""
                    })]
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://pnpm.nodejs.cn/pnpm-workspace_yaml",
              children: "pnpm workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "yarn",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://yarn.nodejs.cn/features/workspaces#how-are-workspaces-declared",
              children: "yarn workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "npm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://npm.nodejs.cn/cli/v7/using-npm/workspaces#defining-workspaces",
              children: "npm workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "bun",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://bun.sh/docs/install/workspaces",
              children: "bun workspace documentation"
            })]
          })]
        }), _jsxs(_components.p, {
          children: ["使用此配置，", _jsx(_components.code, {
            children: "apps"
          }), " 或 ", _jsx(_components.code, {
            children: "packages"
          }), " 目录中每个包含 ", _jsx(_components.code, {
            children: "package.json"
          }), " 的目录都将被视为一个包。"]
        }), _jsxs(_components.p, {
          children: ["¥Using this configuration, every directory ", _jsxs(_components.strong, {
            children: ["with a ", _jsx(_components.code, {
              children: "package.json"
            })]
          }), " in the ", _jsx(_components.code, {
            children: "apps"
          }), " or ", _jsx(_components.code, {
            children: "packages"
          }), " directories will be considered a package."]
        }), _jsxs(Callout, {
          type: "error",
          children: [_jsxs(_components.p, {
            children: ["Turborepo 不支持嵌套包，例如 ", _jsx(_components.code, {
              children: "apps/**"
            }), " 或 ", _jsx(_components.code, {
              children: "packages/**"
            }), "，这是因为 JavaScript 生态系统中的包管理器之间存在行为歧义。使用将一个包放在 ", _jsx(_components.code, {
              children: "apps/a"
            }), " 而另一个包放在 ", _jsx(_components.code, {
              children: "apps/a/b"
            }), " 的结构将导致错误。"]
          }), _jsxs(_components.p, {
            children: ["¥Turborepo does not support nested packages like ", _jsx(_components.code, {
              children: "apps/**"
            }), " or ", _jsx(_components.code, {
              children: "packages/**"
            }), " due to ambiguous behavior among package managers in the JavaScript ecosystem. Using a structure that would put a package at ", _jsx(_components.code, {
              children: "apps/a"
            }), " and another at ", _jsx(_components.code, {
              children: "apps/a/b"
            }), " will result in an error."]
          }), _jsxs(_components.p, {
            children: ["如果你想按目录对软件包进行分组，可以使用像 ", _jsx(_components.code, {
              children: "packages/*"
            }), " 和 ", _jsx(_components.code, {
              children: "packages/group/*"
            }), " 这样的通配符来实现，而无需创建 ", _jsx(_components.code, {
              children: "packages/group/package.json"
            }), " 文件。"]
          }), _jsxs(_components.p, {
            children: ["¥If you'd like to group packages by directory, you can do this using globs like ", _jsx(_components.code, {
              children: "packages/*"
            }), " and ", _jsx(_components.code, {
              children: "packages/group/*"
            }), " and ", _jsx(_components.strong, {
              children: "not"
            }), " creating a ", _jsx(_components.code, {
              children: "packages/group/package.json"
            }), " file."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h4, {
          id: "每个包中的-packagejson-packagejson-in-each-package",
          children: ["每个包中的 ", _jsx(_components.code, {
            children: "package.json"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "package.json"
          }), " in each package"]
        }), _jsxs(_components.p, {
          children: ["在包的目录中，必须有一个 ", _jsx(_components.code, {
            children: "package.json"
          }), " 才能使包管理器和 ", _jsx(_components.code, {
            children: "turbo"
          }), " 能够发现该包。", _jsxs(_components.a, {
            href: "#anatomy-of-a-package",
            children: [_jsx(_components.code, {
              children: "package.json"
            }), " 的要求包"]
          }), " 如下所示。"]
        }), _jsxs(_components.p, {
          children: ["¥In the directory of the package, there must be a ", _jsx(_components.code, {
            children: "package.json"
          }), " to make the package discoverable to your package manager and ", _jsx(_components.code, {
            children: "turbo"
          }), ". The ", _jsxs(_components.a, {
            href: "#anatomy-of-a-package",
            children: ["requirements for the ", _jsx(_components.code, {
              children: "package.json"
            }), " of a package"]
          }), " are below."]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "root-packagejson-root-packagejson",
      children: ["Root ", _jsx(_components.code, {
        children: "package.json"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["根 ", _jsx(_components.code, {
        children: "package.json"
      }), " 是工作区的基础。以下是你在根 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中可以找到的内容的常见示例："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The root ", _jsx(_components.code, {
        children: "package.json"
      }), " is the base for your workspace. Below is a common example of what you would find in a root ", _jsx(_components.code, {
        children: "package.json"
      }), ":"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"pnpm@9.0.0\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"yarn@1.22.19\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"packages/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"npm@10.0.0\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"packages/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"bun@1.2.0\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"packages/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "root-turbojson-root-turbojson",
      children: ["Root ", _jsx(_components.code, {
        children: "turbo.json"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), " 用于配置 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的行为。要了解更多关于如何配置任务的信息，请访问 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: "配置任务"
      }), " 页面。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo.json"
      }), " is used to configure the behavior of ", _jsx(_components.code, {
        children: "turbo"
      }), ". To learn more about how to configure your tasks, visit the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: "Configuring tasks"
      }), " page."]
    }), "\n", _jsx(_components.h3, {
      id: "软件包管理器锁定文件-package-manager-lockfile",
      children: "软件包管理器锁定文件 "
    }), "\n", _jsx(_components.p, {
      children: "¥Package manager lockfile"
    }), "\n", _jsxs(_components.p, {
      children: ["锁文件是包管理器和 ", _jsx(_components.code, {
        children: "turbo"
      }), " 可重现行为的关键。此外，Turborepo 使用锁文件来理解工作区内 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "内部软件包"
      }), " 之间的依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A lockfile is key to reproducible behavior for both your package manager and ", _jsx(_components.code, {
        children: "turbo"
      }), ". Additionally, Turborepo uses the lockfile to understand the dependencies between your ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "Internal Packages"
      }), " within your Workspace."]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: ["如果你在运行 ", _jsx(_components.code, {
          children: "turbo"
        }), " 时没有锁文件，你可能会看到不可预测的行为。"]
      }), _jsxs(_components.p, {
        children: ["¥If you do not have a lockfile present when you run ", _jsx(_components.code, {
          children: "turbo"
        }), ", you may see\nunpredictable behavior."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "软件包结构-anatomy-of-a-package",
      children: "软件包结构 "
    }), "\n", _jsx(_components.p, {
      children: "¥Anatomy of a package"
    }), "\n", _jsxs(_components.p, {
      children: ["通常最好开始考虑将包设计为工作区中的独立单元。从高层次来看，每个包几乎就像一个小型的 \"project\"，拥有自己的 ", _jsx(_components.code, {
        children: "package.json"
      }), "、工具配置和源代码。这个想法有其局限性，但它是一个很好的入门思路。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥It's often best to start thinking about designing a package as its own unit within the Workspace. At a high-level, each package is almost like its own small \"project\", with its own ", _jsx(_components.code, {
        children: "package.json"
      }), ", tooling configuration, and source code. There are limits to this idea—but its a good mental model to ", _jsx(_components.em, {
        children: "start"
      }), " from."]
    }), "\n", _jsxs(_components.p, {
      children: ["此外，包具有特定的入口点，工作区中的其他包可以使用这些入口点访问该包，这些入口点由 ", _jsx(_components.a, {
        href: "#exports",
        children: _jsx(_components.code, {
          children: "exports"
        })
      }), " 指定。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, a package has specific entrypoints that other packages in your Workspace can use to access the package, specified by ", _jsx(_components.a, {
        href: "#exports",
        children: _jsx(_components.code, {
          children: "exports"
        })
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "包的-packagejson-packagejson-for-a-package",
      children: ["包的 ", _jsx(_components.code, {
        children: "package.json"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "package.json"
      }), " for a package"]
    }), "\n", _jsxs(_components.h4, {
      id: "name-name",
      children: [_jsx(_components.code, {
        children: "name"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#name",
        children: [_jsx(_components.code, {
          children: "name"
        }), " 字段"]
      }), " 用于标识包。它在你的工作区内应该是唯一的。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#name",
        children: ["The ", _jsx(_components.code, {
          children: "name"
        }), " field"]
      }), " is used to identify the package. It should be unique within your workspace."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["最佳做法是为 ", _jsx(_components.a, {
          href: "/docs/core-concepts/internal-packages",
          children: "内部软件包"
        }), " 使用命名空间前缀，以避免与 npm 注册表上的其他包冲突。例如，如果你的组织名为 ", _jsx(_components.code, {
          children: "acme"
        }), "，则可以将你的包命名为 ", _jsx(_components.code, {
          children: "@acme/package-name"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥It's best practice to use a namespace prefix for your ", _jsx(_components.a, {
          href: "/docs/core-concepts/internal-packages",
          children: "Internal Packages"
        }), " to avoid conflicts with other packages on the npm registry. For example, if your organization is named ", _jsx(_components.code, {
          children: "acme"
        }), ", you might name your packages ", _jsx(_components.code, {
          children: "@acme/package-name"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["我们在文档和示例中使用 ", _jsx(_components.code, {
          children: "@repo"
        }), "，因为它是 npm 注册表中未使用且不可声明的命名空间。你可以选择保留它或使用你自己的前缀。"]
      }), _jsxs(_components.p, {
        children: ["¥We use ", _jsx(_components.code, {
          children: "@repo"
        }), " in our docs and examples because it is an unused, unclaimable namespace on the npm registry. You can choose to keep it or use your own prefix."]
      })]
    }), "\n", _jsxs(_components.h4, {
      id: "scripts-scripts",
      children: [_jsx(_components.code, {
        children: "scripts"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "scripts"
      }), " 字段用于定义可在包上下文中运行的脚本。Turborepo 将使用这些脚本的名称来确定在包中运行哪些脚本（如果有）。我们在 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "正在运行的任务"
      }), " 页面上详细介绍了这些脚本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "scripts"
      }), " field is used to define scripts that can be run in the package's context. Turborepo will use the name of these scripts to identify what scripts to run (if any) in a package. We talk more about these scripts on the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "Running Tasks"
      }), " page."]
    }), "\n", _jsxs(_components.h4, {
      id: "exports-exports",
      children: [_jsx(_components.code, {
        children: "exports"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#exports",
        children: [_jsx(_components.code, {
          children: "exports"
        }), " 字段"]
      }), " 用于指定其他想要使用该包的包的入口点。当你想在另一个包中使用一个包中的代码时，你将从该入口点导入。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#exports",
        children: ["The ", _jsx(_components.code, {
          children: "exports"
        }), " field"]
      }), " is used to specify the entrypoints for other packages that want to use the package. When you want to use code from one package in another package, you'll import from that entrypoint."]
    }), "\n", _jsxs(_components.p, {
      children: ["例如，如果你有一个 ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 包，则可能具有以下 ", _jsx(_components.code, {
        children: "exports"
      }), " 字段："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For example, if you had a ", _jsx(_components.code, {
        children: "@repo/math"
      }), " package, you might have the following ", _jsx(_components.code, {
        children: "exports"
      }), " field:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \".\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/constants.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./add\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/add.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./subtract\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/subtract.ts\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["请注意，此示例为了简单起见使用了 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "Just-in-Time 包"
      }), " 模式。它直接导出 TypeScript，但你也可以选择使用 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#compiled-packages",
        children: "编译包"
      }), " 模式。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Note that this example uses the ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "Just-in-Time Package"
      }), " pattern for simplicity. It exports TypeScript directly, but you might choose to use the ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#compiled-packages",
        children: "Compiled Package"
      }), " pattern instead."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["本例中的 ", _jsx(_components.code, {
          children: "exports"
        }), " 字段需要 Node.js 和 TypeScript 的现代版本。"]
      }), _jsxs(_components.p, {
        children: ["¥The ", _jsx(_components.code, {
          children: "exports"
        }), " field in this example requires modern versions of Node.js and\nTypeScript."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["这将允许你从 ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 包中导入 ", _jsx(_components.code, {
        children: "add"
      }), " 和 ", _jsx(_components.code, {
        children: "subtract"
      }), " 函数，如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This would allow you to import ", _jsx(_components.code, {
        children: "add"
      }), " and ", _jsx(_components.code, {
        children: "subtract"
      }), " functions from the ", _jsx(_components.code, {
        children: "@repo/math"
      }), " package like so:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/src/index.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { GRAVITATIONAL_CONSTANT"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " SPEED_OF_LIGHT } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/math'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { add } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/math/add'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { subtract } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/math/subtract'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "以这种方式使用导出有三大好处："
    }), "\n", _jsx(_components.p, {
      children: "¥Using exports this way provides three major benefits:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["避免使用 barrel 文件：Barrel 文件是重新导出同一包中其他文件的文件，为整个包创建一个入口点。虽然它们看起来很方便，但它们是 ", _jsx(_components.a, {
            href: "https://vercel.com/blog/how-we-optimized-package-imports-in-next-js#what's-the-problem-with-barrel-files",
            children: "编译器和打包器难以处理"
          }), " 的固有特性，很快就会导致性能问题。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Avoiding barrel files"
          }), ": Barrel files are files that re-export other files in the same package, creating one entrypoint for the entire package. While they might appear convenient, they're ", _jsx(_components.a, {
            href: "https://vercel.com/blog/how-we-optimized-package-imports-in-next-js#what's-the-problem-with-barrel-files",
            children: "difficult for compilers and bundlers to handle"
          }), " and can quickly lead to performance problems."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["更强大的功能：与 ", _jsxs(_components.a, {
            href: "https://nodejs.cn/api/packages.html#main",
            children: [_jsx(_components.code, {
              children: "main"
            }), " 字段"]
          }), " 相比，", _jsx(_components.code, {
            children: "exports"
          }), " 还具有其他强大的功能，例如 ", _jsx(_components.a, {
            href: "https://nodejs.cn/api/packages.html#conditional-exports",
            children: "条件导出"
          }), "。一般来说，我们建议尽可能使用 ", _jsx(_components.code, {
            children: "exports"
          }), " 而不是 ", _jsx(_components.code, {
            children: "main"
          }), "，因为它是更现代的选择。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "More powerful features"
          }), ": ", _jsx(_components.code, {
            children: "exports"
          }), " also has other powerful features compared to ", _jsxs(_components.a, {
            href: "https://nodejs.cn/api/packages.html#main",
            children: ["the ", _jsx(_components.code, {
              children: "main"
            }), " field"]
          }), " like ", _jsx(_components.a, {
            href: "https://nodejs.cn/api/packages.html#conditional-exports",
            children: "Conditional Exports"
          }), ". In general, we recommend using ", _jsx(_components.code, {
            children: "exports"
          }), " over ", _jsx(_components.code, {
            children: "main"
          }), " whenever possible as it is the more modern option."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["IDE 自动补全：通过使用 ", _jsx(_components.code, {
            children: "exports"
          }), " 指定包的入口点，你可以确保代码编辑器能够为包的导出提供自动补全功能。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "IDE autocompletion"
          }), ": By specifying the entrypoints for your package using ", _jsx(_components.code, {
            children: "exports"
          }), ", you can ensure that your code editor can provide auto-completion for the package's exports."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.h4, {
      id: "imports可选-imports-optional",
      children: [_jsx(_components.code, {
        children: "imports"
      }), "（可选） "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "imports"
      }), " (optional)"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#imports",
        children: [_jsx(_components.code, {
          children: "imports"
        }), " 字段"]
      }), " 为你提供了一种在软件包中创建指向其他模块的子路径的方法。你可以将这些视为 \"shortcuts\"，以编写更简单的导入路径，这些路径对于移动文件的重构更具弹性。要了解如何操作，请访问 ", _jsx(_components.a, {
        href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
        children: "TypeScript 页面"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "https://nodejs.cn/api/packages.html#imports",
        children: ["The ", _jsx(_components.code, {
          children: "imports"
        }), " field"]
      }), " gives you a way to create subpaths to other modules within your package. You can think of these like \"shortcuts\" to write simpler import paths that are more resilient to refactors that move files. To learn how, visit ", _jsx(_components.a, {
        href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
        children: "the TypeScript page"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["你可能更熟悉 TypeScript 的 ", _jsx(_components.code, {
          children: "compilerOptions#paths"
        }), " 选项，它可以实现类似的目标。从 TypeScript 5.4 开始，TypeScript 可以从 ", _jsx(_components.code, {
          children: "imports"
        }), " 推断子路径，由于你将使用 Node.js 约定，因此它是一个更好的选择。更多信息请访问 ", _jsx(_components.a, {
          href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
          children: "我们的 TypeScript 指南"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥You may be more familiar with TypeScript's ", _jsx(_components.code, {
          children: "compilerOptions#paths"
        }), " option, which accomplishes a similar goal. As of TypeScript 5.4, TypeScript can infer subpaths from ", _jsx(_components.code, {
          children: "imports"
        }), ", making it a better option since you'll be working with Node.js conventions. For more information, visit ", _jsx(_components.a, {
          href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
          children: "our TypeScript guide"
        }), "."]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "源代码-source-code",
      children: "源代码 "
    }), "\n", _jsx(_components.p, {
      children: "¥Source code"
    }), "\n", _jsxs(_components.p, {
      children: ["当然，你的包中也需要包含一些源代码。包通常使用 ", _jsx(_components.code, {
        children: "src"
      }), " 目录存储其源代码，并编译到 ", _jsx(_components.code, {
        children: "dist"
      }), " 目录（该目录也应位于包内），但这并非强制要求。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Of course, you'll want some source code in your package. Packages commonly use a ", _jsx(_components.code, {
        children: "src"
      }), " directory to store their source code and compile to a ", _jsx(_components.code, {
        children: "dist"
      }), " directory (that should also be located within the package), although this is not a requirement."]
    }), "\n", _jsx(_components.h2, {
      id: "常见陷阱-common-pitfalls",
      children: "常见陷阱 "
    }), "\n", _jsx(_components.p, {
      children: "¥Common pitfalls"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果你使用的是 TypeScript，则可能不需要在工作区根目录中安装 ", _jsx(_components.code, {
            children: "tsconfig.json"
          }), "。软件包应该独立指定其自身的配置，通常基于工作区中单独软件包的共享 ", _jsx(_components.code, {
            children: "tsconfig.json"
          }), " 构建。更多信息请访问 ", _jsx(_components.a, {
            href: "/docs/guides/tools/typescript#you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
            children: "TypeScript 指南"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If you're using TypeScript, you likely don't need a ", _jsx(_components.code, {
            children: "tsconfig.json"
          }), " in the root of your workspace. Packages should independently specify their own configurations, usually building off of a shared ", _jsx(_components.code, {
            children: "tsconfig.json"
          }), " from a separate package in the workspace. For more information, visit ", _jsx(_components.a, {
            href: "/docs/guides/tools/typescript#you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
            children: "the TypeScript guide"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["你希望尽可能避免跨包访问文件。如果你发现自己需要编写 ", _jsx(_components.code, {
            children: "../"
          }), " 来从一个包切换到另一个包，那么你可能有机会重新思考你的方法，方法是将包安装在需要的位置并将其导入到代码中。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥You want to avoid accessing files across package boundaries as much as possible. If you ever find yourself writing ", _jsx(_components.code, {
            children: "../"
          }), " to get from one package to another, you likely have an opportunity to re-think your approach by installing the package where it's needed and importing it into your code."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsxs(_components.p, {
      children: ["配置好工作区后，你现在可以使用包管理器来运行 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies",
        children: "将依赖安装到你的包中"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥With your Workspace configured, you can now use your package manager to ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies",
        children: "install dependencies into your packages"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
